import { getFreshTokensAndClaims, useMSALPayload } from "@initia-digital/auth-client-utils";
import { UIS3ObjectStorageClient } from "@initia-digital/data-sdk";
import { BasicLogger, S3 } from "@initia-digital/ts-utils";
import { CredentialInput } from "@initia-digital/types/service";
import { Buffer } from 'buffer';


const logger = new BasicLogger({ logLevel: import.meta.env.VITE_ENV_LOWER === 'prod' ? 0 : 2, logFormat: 'BROWSER' })

const objectStorageService = new UIS3ObjectStorageClient({
    env: import.meta.env.VITE_ENV_LOWER,
    credentialProviderProps: {
        authProvider: import.meta.env.VITE_AUTH_PROVIDER,
        region: 'ap-southeast-2',
        identityPoolId: import.meta.env.VITE_AUTH_COGNITO_IDENTITY_POOL_ID,
    },
    logger
});


export const getS3Object = async (
    authDetail: Awaited<ReturnType<typeof useMSALPayload>>,
    params: {
        path: string
    }
) => {
    // ------------------------------
    const { msal } = authDetail;
    const { idToken } = await getFreshTokensAndClaims(msal, { scopes: ["openid", "profile", "User.Read", "User.Read.All", "offline_access"] });

    const credentialsInput = {
        type: "CognitoIdentity",
        idToken,
        service: 's3'
    } as CredentialInput;

    const { path } = params;

    const response = await objectStorageService.getObject(credentialsInput, {
        bucket: import.meta.env.VITE_S3_STORAGE_BUCKET,
        path: S3.toSafePath(path)
    });

    return response;
}


export const putS3Object = async (
    authDetail: Awaited<ReturnType<typeof useMSALPayload>>,
    params: {
        file: File,
        path: string
    }
) => {
    // ------------------------------
    const { msal } = authDetail;
    const { idToken } = await getFreshTokensAndClaims(msal, { scopes: ["openid", "profile", "User.Read", "User.Read.All", "offline_access"] });

    const credentialsInput = {
        type: "CognitoIdentity",
        idToken,
        service: 's3'
    } as CredentialInput;

    const { file, path } = params;

    const arrayBuffer = await file.arrayBuffer();
    const uint8Array = new Uint8Array(arrayBuffer);
    const buffer = Buffer.from(uint8Array);

    const response = await objectStorageService.putObject(
        credentialsInput,
        {
            bucket: import.meta.env.VITE_S3_STORAGE_BUCKET,
            path: S3.toSafePath(path),
            buffer
        }
    );
    return response;
}